import React from "react";

const PrivacyContent = ({ businessName, websiteUrlVal, websiteBackgroundColor }) => {

  // const website_url = process.env.REACT_APP_MAIN_URL

  const websiteUrl = `https://${websiteUrlVal}`

  return (
    <div className="section" style={{backgroundColor: websiteBackgroundColor}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="post-content">
              <p>
                We at <strong>{businessName}</strong>{" "}
                (the "Business" "we" or "us" in this Privacy Policy), operator
                of the web site at{" "}
                <b>
                  <a href={websiteUrl} target="blank">
                    {websiteUrl}
                  </a>
                </b>{"    "}
                (the "Site"), understand the importance of the privacy of users
                of the Site, and in particular of protecting their personal
                information. We have therefore put in place this Privacy Policy
                in compliance with the Canadian Personal Information Protection
                and Electronic Documents Act ("PIPEDA") and Canada`s Anti-Spam
                Legislation, in order to inform you fully of our privacy
                practices, and to permit you to contact us with any concerns,
                questions, or corrections regarding your personal information in
                our possession.
              </p>
              <h3>1. Accountability</h3>
              <p>
                Business has provided this privacy policy for ensuring
                compliance with the requirements of PIPEDA and Canada`s
                Anti-Spam Legislation. Should you have any questions regarding
                this policy or concerns with respect to Business`s compliance
                with the requirements of PIPEDA or Canada`s Anti-Spam
                Legislation, you may contact us.
              </p>
              <h3>2. Identifying Purpose of Collection</h3>
              <p>
                We collect various personal information from you when you seek
                our products or services, make an online reservation, sing-up to
                our VIP newsletter membership or any inquiry through the Site.
                Information collected may include your:
              </p>
              <ul>
                <li>- Full Name</li>
                <li>- Company Name</li>
                <li>- Address(es)</li>
                <li>- Telephone and Facsimile number(s)</li>
                <li>- Email address(es)</li>
                <li>- Gender</li>
                <li>- Interest(s)</li>
                <li>
                  <b>We collect this information in order to permit us to:</b> -
                  Verify your identity,
                </li>
                <li>
                  - Permit us to contact you to provide goods and services
                  requested by you,
                </li>
                <li>
                  - Provide you with periodic updates regarding the Site and our
                  products and services.
                </li>
              </ul>
              <p>
                We may also use such information to build a profile of your
                interests as they relate to the Site or Business, so that we
                will be able to suggest or provide products or services of
                interest to you in the future.
              </p>
              <p>
                We do not collect information which we do not reasonably require
                in order to fulfill these purposes.
              </p>
              <b>
                Further, the Site automatically collects certain information
                every time you visit it:
              </b>
              <h6>a) Cookies</h6>
              <p>
                A cookie is a small non-executable file that is stored on your
                hard drive for the purpose of identifying your computer. While
                it is possible to view and to acquire products and services from
                the site with your browser`s security settings set to prevent
                cookies from being used, your online experience may be greatly
                reduced.
              </p>
              <p>
                Business uses both session cookies and permanent cookies at Site
                only after you have created a user account on the platform.
                Session cookies are active only during the period you are logged
                on to the Site and are removed when you leave.
              </p>
              <p>
                Permanent cookies remain on your hard drive until you remove
                them through your browser`s Internet security settings.
                Permanent cookies are used to store login information and user
                preferences, and thus eliminate your having to make the same
                entries on each visit.
              </p>

              <h6>b) Conversion Beacons</h6>
              <p>
                Business also uses Conversion Beacons (short bits of HTML
                computer code) inserted in the source code of designated website
                pages. These beacons, used with industry standard browser cookie
                technology and standard html coding, allow us to track analytics
                to the Site and email flow between you and us. Email recipients
                who receive a Conversion Beacon enabled email message will
                receive a small unique cookie that is stored in their browser
                session, which is later used to connect the email recipient with
                the subsequent recipient activity on the Site.
              </p>
              <b>Consent and CEMs</b>
              <p>
                When you acquire any product or service on or through the Site,
                or you provide any information at our request, your action
                constitutes consent to our collection and use of such
                information as permitted in this Privacy Policy and Canada`s
                Anti-Spam Legislation.
              </p>
              <p>
                Express consent is obtained when you explicitly toggle the
                opt-in check-box to agree express permission for us to send you
                commercial electronic messages ("CEM").
              </p>
              <p>
                Implied consent is obtained when you have purchased our goods or
                services and have provided your email address from a
                reservation, comment form, coupon or other method.
              </p>
              <p>
                Implied consent is obtained when you have purchased our goods or
                services and have provided your email address from a
                reservation, comment form, coupon or other method.
              </p>
              <p>
                Email communications are sent from a software provided by Plento Inc. All email communications include the Business name,
                contact and a mechanism that allows the recipient to unsubscribe
                at no cost as per the requirements of Canada`s Anti-Spam
                Legislation.
              </p>
              <p>
                Please note that if you do not wish to receive emails from us,
                you may opt out automatically of such material by clicking on
                the unsubscribe link found in the email communication sent to
                you by our Business.
              </p>
              <p>
                You may also opt out of certain other uses of your data by
                contacting us.
              </p>

              <h3>3. Limiting Collection</h3>
              <p>
                Business will limit the collection of personal information to
                that which reasonably necessary to fulfill the purpose for which
                it was collected.
              </p>
              <p>
                Research and survey data is reported back to Business as
                aggregated data with no reference to individual customers.
              </p>
              <p>
                Customers who do not wish to be contacted for research or survey
                purposes should contact us.
              </p>

              <h3>4. Limiting Use, Disclosure and Retention</h3>
              <p>
                We will not use or disclose your personal information for
                purposes other than those for which it was collected without
                your consent or as permitted or required by law.
              </p>
              <p>
                However, we do use the services of third parties to complete
                certain electronic requests such as reservations, newsletter
                sign-ups along with any other 3rd party widgets, and your
                personal information may therefore be transmitted to such third
                parties for such purposes. If your personal data is to be
                transmitted to another party for processing or storage, we use
                contractual and other means to ensure that your personal
                information is protected in accordance with PIPEDA.
              </p>
              <p>
                Your user data will be stored by Plento Inc, Plento’s privacy policy
                can be found at <b>
                  <a href={websiteUrl} target="blank">
                    {websiteUrl}
                  </a>
                </b>.
              </p>
              <p>
                Your personal information is retained only for as long as
                necessary to fulfill the purposes for which it was collected,
                unless the law requires longer retention.
              </p>

              <h3>5. Accuracy</h3>
              <p>
                In order to maintain the highest levels of accuracy regarding
                your personal information, to the extent possible we permit you
                to enter such information into our systems yourself. In some
                instances, however, we are required to enter such information,
                for instance upon speaking to you over the phone or some other
                type of communication (provided by you or otherwise).
              </p>

              <h3>6. Safeguards</h3>
              <p>
                While in our possession (or the possession of any entity engaged
                by us to house or store it) and regardless of the format in
                which it is held, your personal information is protected against
                theft, loss and/or unauthorized access, disclosure, copying, use
                or modification by security safeguards appropriate to the
                sensitivity of the information.
              </p>
              <p>
                Some personal information entered by you into our systems may be
                encrypted as it travels over the Internet. Depending on your web
                browser you may see a secure webpage indicator, for example a
                closed lock in the lower right-hand corner of your browser. We
                may use the Secure Socket Layer (SSL) protocol to encrypt some
                personal information as it travels from your computer to our
                systems.
              </p>

              <h3>7. Openness</h3>
              <p>
                Business`s privacy practices are as outlined within this policy.
                If you have any questions or comments, please contact us.
              </p>

              <h3>8. Individual Access</h3>
              <p>
                With certain limited exceptions as provided in the PIPEDA you
                have a right to access your personal information held by the
                Business. You may access your personal information by contacting
                us.
              </p>

              <h3>9. Challenging Compliance</h3>
              <p>
                If you have any concerns regarding Business`s compliance with
                the 10 principles of the PIPEDA or Canada`s Anti-Spam
                Legislation you may address those concerns to us. Complaints
                concerning Business`s compliance with PIPEDA are taken seriously
                and all complaints are investigated.
              </p>
              <b>Changes to the Privacy Policy</b>
              <p>
                Business reserves the right to modify this privacy statement at
                any time, so please review it frequently. If we make material
                changes to this policy we will notify you on our homepage and
                other places we deem appropriate so that you are aware of what
                information we collect, how we use it, and under what
                circumstances, if any, we disclose it.
              </p>

              <h2>Refund and Cancellation Policy:</h2>

              <h3>1. Cancellation</h3>
              <p>
                i. As a general rule you shall not be entitled to cancel your
                order once you have received confirmation of the same. If you
                cancel your order after it has been confirmed, the restaurant
                will have the right to either not to refund the order value or
                recover from your subsequent order, the complete/ deficit
                cancellation fee, as applicable, to compensate our restaurant
                and delivery partners. In case of cancellations for the reasons
                attributable to the restaurant and delivery partners, the
                restaurant shall not charge you any cancellation fee.
              </p>
              <p>
                ii. However, in the unlikely event of an item on your order
                being unavailable, we will contact you on the phone number
                provided to us at the time of placing the order and inform you
                of such unavailability. In such an event you will be entitled to
                cancel the entire order and shall be entitled to a refund in
                accordance with our refund policy.
              </p>
              <p>
                iii. We reserve the sole right to cancel your order in the
                following circumstance:
              </p>
              <p>
                a. in the event of the designated address falls outside the
                delivery zone offered by us;
              </p>
              <p>
                b. failure to contact you by phone or email at the time of
                confirming the order booking;
              </p>
              <p>
                c. failure to deliver your order due to lack of information,
                direction or authorization from you at the time of delivery; or
              </p>
              <p>
                d. unavailability of all the items ordered by you at the time of
                placing the order;
              </p>
              <p>
                e. unavailability of all the items ordered by you at the time of
                placing the order;
              </p>

              <h3>2. Refunds</h3>
              <p>
                i. You shall be entitled to a refund only if you pre-pay for
                your order at the time of placing your order on the Platform and
                only in the event of any of the following circumstances:
              </p>
              <p>
                a. your order packaging has been tampered or damaged at the time
                of delivery;
              </p>
              <p>
                b. us cancelling your order due to (A) your delivery location
                following outside our designated delivery zones; (B) failure to
                contact you by phone or email at the time of confirming the
                order booking; or (C) failure to contact you by phone or email
                at the time of confirming the order booking; or
              </p>
              <p>
                c. you cancelling the order at the time of confirmation due to
                unavailability of the items you ordered for at the time of
                booking.
              </p>
              <p>
                ii. Our decision on refunds shall be at our sole discretion and
                shall be final and binding.
              </p>
              <p>
                iii. All refund amounts shall be credited to your account within
                5-7 business days in accordance with the terms that may be
                stipulated by the bank which has issued the credit / debit card.
              </p>
              <h3>
                3. In case of payment at the time of delivery, you will not be
                required to pay for:
              </h3>
              <p>
                i. orders where the packaging has been tampered or damaged by
                us;
              </p>
              <p>ii. wrong order being delivered; or</p>
              <p>iii. items missing from your order at the time of delivery.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyContent;
